import Axios from '../utils/Axios';

export type AreaType = {
  area_name: string;
  area_number: 1;
  room: RoomType[];
};
export type RoomType = {
  device_list: DeviceType[];
  name: string;
  is_deleted?: boolean;
  number?: number;
  area_id: number;
  area_grade_name: string | null;
  area_grade_id: number | null;
};
export type DeviceType = {
  area_number: number;
  device_app_state: string;
  device_battery: number;
  device_is_charging: number;
  device_issue: string;
  device_updated_at: string;
  device_volume: number;
  loggedin_at: string;
  loggedout_at: string;
  number: number;
  user_token_id: number;
  device_power: number;
  device_wifi_power: number;
  device_memo: string | null;
  name?: string;
  device_status: string;
  normal: number;
  is_connected?: number;
  logged_at?: any;
};
export type PickUpZoneType = {
  pickup_id?: number;
  pickup_name: string;
  pickup_name_en: string | null | undefined;
  start_time: string;
  end_time: string;
};
export type EditStoreType = {
  store_id: number;
  store_name: string;
  store_name_en: string | null | undefined;
  address1: string;
  address2: string;
  phone_number: string;
  store_detail: any;
  description_noti: any;
  description_event: any;
  description_extra: any;
};
export type RoomTipType = {
  order_price: number;
  room_tip: number;
};
export type RoomListType = {
  area_grade_id: number;
  area_grade_name: string;
  cost_list: RoomListCostType[];
  id_order: number;
  store_id: number;
  count: number;
  late_checkout: boolean;
};
export type CheckoutRoomListType = {
  area_grade_id: number;
  area_grade_name: string;
  id_order: number;
  lateCheckoutByExtendType: LateCheckoutByExtendType[];
  store_id: number;
};
export type LateCheckoutByExtendType = {
  extend_type: number;
  late_checkout: boolean;
};

export type RoomListCostType = {
  area_grade_id: number;
  base_price: number;
  hour_extension: number;
  name: string;
  org_price: number;
  product_id: number;
  apply_day: number[];
  extend_type: number[];
  exposure_type: number[];
};
export type roomAssignmentNotificationListType = {
  noticeDetailId: number;
  noticeAt: string;
  content: string;
  areaIdGroup: string;
  isSent: boolean;
  areaNames: string[];
  noticeTime?: string;
};

const HotelController = {
  // 기기목록 불러오기
  getDevice: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/getDevice`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기기목록 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 구역 추가하기
  setArea: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setArea';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[구역 추가하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 구역 추가하기
  editArea: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editArea';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[구역 수정하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 객실 추가하기
  setRoom: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setRoom';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[객실 추가하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 픽업존
  getPickUpZone: async (storeId: number) => {
    try {
      console.log('process.env', process.env);
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${storeId}/getPickUpZone`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[픽업존 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setPickUpZone: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setPickUpZone';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[픽업존 설정하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  delPickUpZone: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delPickUpZone';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[픽업존 삭제하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 객실관리팁
  getRoomtip: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getRoomtip';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[객실관리팁 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setRoomtip: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setRoomtip';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[객실관리팁 설정하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 룸타입설정
  getRoomType: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getRoomType';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[룸타입 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setRoomType: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setRoomType';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[룸타입설정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getLatecheckoutFlag: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/checkout/getLatecheckoutFlag';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[퇴실알림 룸타입 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setLateCheckoutFlag: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/checkout/setLateCheckoutFlag';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[퇴실알림 룸타입 등록 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  editRoomType: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editRoomType';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[룸타입수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  delRoomType: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delRoomType';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[룸타입삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 객실 판매 설정
  setCheckOut: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setCheckOut';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[퇴실 상품 설정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  editCheckOut: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editCheckOut';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[퇴실 상품 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  delCheckOut: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delCheckOut';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[퇴실 상품 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  setAlert: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setAlert';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[알림 상세 설정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getRegularNotificationList: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/checkout/getRegularNotificationList';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[일괄알림 리스트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getRoomAssignmentNotificationList: async (oParams: any) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL + '/checkout/getRoomAssignmentNotificationList';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호실지정알림 리스트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  delAlert: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delAlert';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호실지정알림 리스트 삭제하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 퇴실알람 저장 문구 최대 4개 불러오기
  getLatestCheckoutSentence: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/checkout/getLatestCheckoutSentence';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[퇴실알람 저장 문구 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default HotelController;
